import React from 'react';
import { Stack, Typography } from '@mui/material';
import { primary } from '@/theme/colors';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';

export const CommentsFallbackMessage = ({ type }: { type: 'selection' | 'empty' }) => {
  return (
    <Stack
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding={2}
      textAlign="center"
      marginY="18rem"
      gap={'2rem'}
    >
      <AbyssIcon iconName="comments" style={{ width: '2.4rem', height: '2.4rem' }} />
      <Typography fontSize="1.2rem" color={primary.light} lineHeight="normal">
        {type === 'empty' && 'No comments are available for this item at the moment.'}
        {type === 'selection' && ' Click on the any value from the table to see related comments.'}
      </Typography>
    </Stack>
  );
};
